export default {
  item: {
    width: "100%"
  }
}
